import httpClient from './httpClient'

export default {
  AdvancedVcaEvent: {
    Search(payload) {
      return httpClient.post('AdvancedVcaEvent/Search', payload)
    },
  },
}
